import React, { useEffect, useState, useRef } from "react";
import { DateRange } from "react-date-range";
import format from "date-fns/format";
import { addDays, startOfWeek } from "date-fns";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";

const DateRangeCompOnboarding = ({ onRangeChange }) => {
  const [range, setRange] = useState([
    {
      startDate: addDays(new Date(), -7),
      endDate: new Date(),
      key: "selection",
    },
  ]);

  const [open, setOpen] = useState(false);
  const refOne = useRef(null);

  useEffect(() => {
    const { startDate, endDate } = range[0];
    onRangeChange(startDate, endDate);
  }, [range, onRangeChange]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (refOne.current && !refOne.current.contains(e.target)) {
        setOpen(false);
      }
    };

    const handleEscape = (e) => {
      if (e.key === "Escape") {
        setOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    document.addEventListener("keydown", handleEscape);

    return () => {
      document.removeEventListener("click", handleClickOutside);
      document.removeEventListener("keydown", handleEscape);
    };
  }, []);

  const monthsShow = window.matchMedia("(max-width: 1100px)").matches ? 1 : 2;

  return (
    <div className="calendarWrap">
      {open && <div className="caldendarDark" onClick={() => setOpen(false)} />}
      <div ref={refOne}>
        <input
          value={`${format(range[0].startDate, "MM/dd/yyyy")} to ${format(range[0].endDate, "MM/dd/yyyy")}`}
          readOnly
          className="inputBox"
          onClick={() => setOpen((prev) => !prev)}
          placeholder="Choose period"
        />
        {open && (
          <DateRange
            onChange={(item) => setRange([item.selection])}
            editableDateInputs={true}
            moveRangeOnFirstSelection={false}
            showDateDisplay={false}
            ranges={range}
            months={monthsShow}
            direction="horizontal"
            className="calendarElement"
          />
        )}
      </div>
    </div>
  );
};

export default DateRangeCompOnboarding;
